<template>
  <div :class="['btn-group', className]" :style="customStyles ? customStyles.div : null">
    <button
      type="button"
      class="btn mat dropdown-toggle"
      id="filter-dropdown"
      :style="customStyles ? customStyles.button : null"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span class="pull-left">Filter ({{ filterCount }})</span>
      <span :class="caret" :style="customStyles ? customStyles.caret : null"></span>
    </button>

    <ul class="dropdown-menu" :style="customStyles ? customStyles.ul : null" @click.stop>
      <form @submit.prevent="onSubmit()">
        <div v-for="(qualifierKeys, qualifier) in qualifiers" :key="qualifier">
          <h5 class="font-bold">{{ qualifier }}</h5>

          <template v-if="qualifierKeyCounts[qualifier]">
            <div :class="qualifierKeyCounts[qualifier] > 14 ? 'pre-scrollable' : null">
              <li v-for="(data, key) in qualifierKeys" :key="key">
                <label :for="key">
                  <input
                    type="checkbox"
                    :id="key"
                    v-model="localFilters[qualifier].selection[key]"
                    @change="onChange(key, qualifier)"
                  />
                  <slot v-bind:data="data" v-bind:qualifier="qualifier"></slot>
                </label>
              </li>
            </div>
            <p class="options">
              <a href="#" @click="clearSelection(qualifier)">Clear</a>
              <a href="#" class="pull-right" @click="selectAll(qualifier)">Select All</a>
            </p>
          </template>
          <template v-else>
            <p>No {{ qualifier }} created.</p>
          </template>

          <li role="presentation" class="divider"></li>
        </div>

        <button class="btn btn-primary font-bold" :disabled="!changed">Apply</button>
      </form>
    </ul>
  </div>
</template>

<script>
  import Vue from 'vue';
  export default {
    props: {
      qualifiers: {
        type: Object,
        required: true,
      },
      applyFilter: {
        type: Function,
        required: true,
      },
      className: {
        type: String,
        required: false,
      },
      customStyles: {
        type: Object,
        required: false,
      },
      caret: {
        type: String,
        required: false,
        default: 'caret',
      },
    },
    data() {
      return {
        localFilters: {},
        changed: false,
      };
    },

    beforeMount() {
      Object.keys(this.qualifiers).forEach((qualifier) => {
        Vue.set(this.localFilters, qualifier, {
          selection: {},
          count: 0,
        });
      });
    },

    computed: {
      filterCount() {
        return Object.values(this.localFilters).reduce((total, { count }) => {
          return (total += count);
        }, 0);
      },
      qualifierKeyCounts() {
        return Object.entries(this.qualifiers).reduce((counts, [qualifier, qualifierKeys]) => {
          counts[qualifier] = Object.values(qualifierKeys).length;
          return counts;
        }, {});
      },
    },

    methods: {
      onSubmit() {
        this.applyFilter(this.localFilters);
        this.changed = false;
      },
      onChange(key, qualifier) {
        const selectedFilter = this.localFilters[qualifier];
        if (!(key in selectedFilter.selection) || !selectedFilter.selection[key]) {
          selectedFilter.count -= 1;
        } else if (selectedFilter.selection[key]) {
          selectedFilter.count += 1;
        }
        this.changed = true;
      },
      clearSelection(qualifier) {
        const selectedFilter = this.localFilters[qualifier];
        Object.keys(selectedFilter.selection).forEach((key) => {
          selectedFilter.selection[key] = false;
        });
        selectedFilter.count = 0;
        this.changed = true;
      },
      selectAll(qualifier) {
        const selectedFilter = this.localFilters[qualifier];
        const src = this.qualifiers[qualifier];

        selectedFilter.count = 0;
        Object.keys(src).forEach((key) => {
          selectedFilter.selection[key] = true;
          selectedFilter.count += 1;
        });
        this.changed = true;
      },
    },
  };
</script>

<style lang="scss" scoped>
  form {
    padding: 10px 10px;
    font-size: 12px;
    label {
      font-weight: normal;
    }
    .font-bold {
      font-family: sans-serif;
      font-weight: bold;
    }
    .options {
      margin-top: 5px;
    }
    .question-tag {
      border-radius: 20px;
      display: inline;
      padding: 2px 5px;
      margin: 0px;
    }
    h5 {
      margin-top: 0;
      text-transform: capitalize;
    }
    button {
      width: 100%;
      font-size: 12px;
    }
  }
</style>
